<template>
  <nav class="navbar fixed-top navbar-expand-lg navbar-dark bg-dark sticky">
    <router-link
      class="nav-link navbar-brand"
      active-class="custom-active"
      to="/">
      Mohammad Karim
    </router-link>
    <ThemeSelector is-in-navbar />
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav">
        <navbar-link name="About" to="" />
        <!-- <navbar-link name="Experience" /> -->
        <navbar-link name="Projects" to="projects" />
        <navbar-link name="Academic" />
        <!-- <navbar-link name="Resume" /> -->
        <navbar-link name="Contact" />
      </ul>
    </div>
  </nav>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import NavbarLink from './NavbarLink.vue';
import ThemeSelector from './ThemeSelector.vue';

export default defineComponent({
  name: 'NavbarComponent',
  components: {ThemeSelector, NavbarLink},
});
</script>

<style lang="scss" scoped>
nav {
  padding: 15px 20px;
}
.dropdown--padding {
  padding-left: 10px;
}
</style>

<!-- <li class="nav-item dropdown">
  <a
    class="nav-link dropdown-toggle"
    href="#"
    id="navbarScrollingDropdown"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false">
    Skills
  </a>
  <ul
    class="dropdown-menu dropdown-menu-dark dropdown--padding"
    aria-labelledby="navbarScrollingDropdown">
     <li>
      <navbar-link name="Technical Skills" to="technical-Skills" :is-dropdown="true" />
    </li> -->
<!-- <li>
      <navbar-link name="Leadership" :is-dropdown="true" />
    </li>
    <li>
      <navbar-link name="Teamwork" :is-dropdown="true" />
    </li>
  </ul>
</li> -->
